import styled, { css } from "styled-components";

interface ModalHeaderProps {
  readonly modalTheme: string;
  readonly isMobile: boolean;
}

export const StyledHeader = styled.div<ModalHeaderProps>`
  max-width: 100%;
  text-transform: uppercase;
  color: ${(props) => handlerColorTheme(props.modalTheme)};
  letter-spacing: 3px;
  ${(props) =>
    props.isMobile &&
    css`
      margin-top: 10px;
      margin-bottom: 10px;
      letter-spacing: 1px;
    `}
`;

const handlerColorTheme = (theme: string) => {
  switch (theme) {
    case "primary":
      return "#000";

    case "secondary":
      return "#fff";

      default:
        return "#000";
  }
};

StyledHeader.defaultProps = {};
